import React, { Component } from 'react'
import Picker from 'react-month-picker'

import PickerBox from './PickerBox'
import FilterSelect from './FilterSelect'
import RangeSlider from './RangeSlider'

import { labelsCategory, linksCategory, labelsSchool, labelsLevel, labelsLicense, pickerLang, filterLevel } from './data'

class Filters extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectSchool: this.props.usedFilters.school,
      selectCategory: this.props.usedFilters.category,
      selectLevel: this.props.usedFilters.level,
      selectLicense: this.props.usedFilters.license,
      dateRange: this.props.usedFilters.range,
      ageRange: this.props.usedFilters.age
    }
    /* TODO: Initial-Filter/Reset vereinfachen */
    this.originalFilters = {
      selectSchool: this.props.initialFilter.school,
      selectCategory: this.props.initialFilter.category,
      selectLevel: this.props.initialFilter.level,
      selectLicense: this.props.initialFilter.license,
      dateRange: this.props.initialFilter.range,
      ageRange: this.props.initialFilter.age
    }

    this.filterSchool = this.filterSchool.bind(this)
    this.openSchool = this.openSchool.bind(this)
    this.filterCategory = this.filterCategory.bind(this)
    this.openCategory = this.openCategory.bind(this)
    this.filterLevel = this.filterLevel.bind(this)
    this.openLevel = this.openLevel.bind(this)
    this.filterLicense = this.filterLicense.bind(this)
    this.openLicense = this.openLicense.bind(this)
    this.filterAge = this.filterAge.bind(this)
    this.handleClickRangeBox = this.handleClickRangeBox.bind(this)
    this.handleRangeChange = this.handleRangeChange.bind(this)
    this.toggleFilters = this.toggleFilters.bind(this)
    this.resetFilters = this.resetFilters.bind(this)
  }

  /**
   * Set the filter for school.
   */
  filterSchool (e) {
    this.props.exchangeFilter(e.value, 'school')
    this.setState({ selectSchool: e.value })
  }

  /**
   * Set the filter for school to all. This is to show all options if the user opens a select, where a filter was already selected. If it was not "all", no option would be available.
   */
  openSchool () {
    this.props.exchangeFilter('all', 'school')
  }

  /**
   * Set the filter for category.
   */
  filterCategory (e) {
    this.props.exchangeFilter(e.value, 'category')
    this.setState({ selectCategory: e.value })
  }

  /**
   * Set the filter for category to all.
   */
  openCategory () {
    this.props.exchangeFilter('all', 'category')
  }

  /**
   * Set the filter for level.
   */
  filterLevel (e) {
    this.props.exchangeFilter(e.value, 'level')
    this.setState({ selectLevel: e.value })
  }

  /**
   * Set the filter for level to all.
   */
  openLevel () {
    this.props.exchangeFilter('all', 'level')
  }

  /**
   * Set the filter for license.
   */
  filterLicense (e) {
    this.props.exchangeFilter(e.value, 'license')
    this.setState({ selectLicense: e.value })
  }

  /**
   * Set the filter for license to all.
   */
  openLicense () {
    this.props.exchangeFilter('all', 'license')
  }

  /**
   * Dismantle and set the filter for age.
   */
  filterAge (e) {
    let ageObj = Object.assign({}, this.state.ageRange)
    ageObj = { from: e.min, to: e.max, single: e.values[0] }
    this.props.exchangeFilter(ageObj, 'age')
    this.setState({ ageRange: ageObj })
  }

  /**
   * Keep the month range picker box open when clicked inside.
   */

  handleClickRangeBox (e) {
    this.refs.pickRange.show()
  }

  /**
   * Set the filter for the month range.
   *
   * @param pickedYear        Selected year, delivered by the monthpicker.
   * @param pickedMonth       Selected month, delivered by the monthpicker.
   * @param pickerIndex       0 = range from, 1 = range to.
   * @var   dateObj           The date object that the picked values will flow into.
   */

  handleRangeChange (pickedYear, pickedMonth, pickerIndex) {
    let dateObj = Object.assign({}, this.state.dateRange)
    if (pickerIndex === 0) {
      dateObj.from = { year: pickedYear, month: pickedMonth }
    } else {
      dateObj.to = { year: pickedYear, month: pickedMonth }
    }
    this.setState({ dateRange: dateObj })
    this.props.exchangeFilter(dateObj, 'range')
  }

  /**
   * Toggle the visibility of the filter bar on mobile.
   *
   * @var   bar   The DOM filter bar.
   */
  toggleFilters () {
    const bar = document.getElementById('filterBar')
    bar.classList.toggle('is--retracted')
  }

  /**
   * Trigger the reset filters function.
   */
  resetFilters () {
    this.props.resetFilters()
    this.setState(this.originalFilters)
  }

  /**
   * Change the filter-bar layout during scroll and on mobile.
   */
  componentDidMount () {
    if (this.props.view !== 'home') {
      const bar = document.getElementById('filterBar')
      bar.classList.add('is--retracted')
      const barPos = bar.getBoundingClientRect().top + document.documentElement.scrollTop - 80
      window.onscroll = function () {
        let isPositionFixed = (bar.classList.contains('is--retractable'))

        let barheight = bar.clientHeight
        const kursfinderlist = document.getElementById('kursfinder-list')

        if (document.documentElement.scrollTop > barPos && !isPositionFixed) {
          bar.classList.add('is--retractable')
          kursfinderlist.style.paddingTop = barheight + 'px'
        }
        if (document.documentElement.scrollTop < barPos && isPositionFixed) {
          bar.classList.remove('is--retractable')
          kursfinderlist.style.paddingTop = '0'
        }
      }
    }
  }

  /**
   * Render function for the filter bar. Here, the bar will be constructed for the 2 views (list / home).
   * 3rd party React elements are: react-select, react-month-picker, rheostat
   */
  render () {
    let dateRange = this.state.dateRange
    const rangeText = m => {
      if (m && m.year && m.month) return (pickerLang.months[m.month - 1] + '. ' + m.year)
      return '?'
    }

    const currentYear = new Date().getFullYear()
    let filterView

    let newDaterange = '&dateRangeFromYear=' + dateRange.from.year + '&dateRangeFromMonth=' + dateRange.from.month + '&dateRangeToYear=' + dateRange.to.year + '&dateRangeToMonth=' + dateRange.to.month

    let requestLink = this.props.targetLink + '?school=' + this.state.selectSchool + '&category=' + this.state.selectCategory + '&age=' + this.state.ageRange.single + '&level=' + this.state.selectLevel + '&license=' + this.state.selectLicense + newDaterange

    if (this.props.view === 'home') {
      filterView =
        <div id='filterBar' className='filter-bar'>
          <div className='filter-row'>
            <FilterSelect selectState={this.state.selectSchool} selectFilter={this.props.staticFilters.school} dynamicFilters={this.props.dynamicFilters.school} selectLabels={labelsSchool} selectText='Alle Orte' selectChange={this.filterSchool} selectOpen={this.openSchool} sortByLabel />
            <FilterSelect selectState={this.state.selectCategory} selectFilter={this.props.staticFilters.category} dynamicFilters={this.props.dynamicFilters.category} selectLinks={linksCategory} selectLabels={labelsCategory} selectText='Alle Kategorien' selectChange={this.filterCategory} selectOpen={this.openCategory} />
            <RangeSlider label='Alter bei Kursbeginn:' rangeState={this.state.ageRange} rangeChange={this.filterAge} />
            <a className='btn btn-outline-primary resultCountDesktop' href={requestLink}>{this.props.resultsCount} Ergebnisse <i className='fa fa-angle-right' /></a>
          </div>

          <div className='filter-row filter-row__picker'>
            <FilterSelect selectState={this.state.selectLevel} selectFilter={filterLevel} dynamicFilters={this.props.dynamicFilters.level} selectLabels={labelsLevel} selectText='Alle Level' selectChange={this.filterLevel} selectOpen={this.openLevel} />
            <FilterSelect selectState={this.state.selectLicense} selectFilter={this.props.staticFilters.license} dynamicFilters={this.props.dynamicFilters.license} selectLabels={labelsLicense} selectText='Alle Führerscheine' selectChange={this.filterLicense} selectOpen={this.openLicense} />
            <div>
              <div>Kurszeitraum:</div>
              <Picker
                ref='pickRange'
                years={{ min: currentYear, max: currentYear + 2 }}
                range={dateRange}
                lang={pickerLang}
                theme='light'
                onChange={this.handleRangeChange}
              >
                <PickerBox value={rangeText(dateRange.from) + ' - ' + rangeText(dateRange.to)} onClick={this.handleClickRangeBox} />
              </Picker>
            </div>
          </div>
          <div className='resultCountMobile' >
            <a className='btn btn-outline-primary' href={requestLink}>{this.props.resultsCount} Ergebnisse <i className='fa fa-angle-right' /></a>
          </div>
          <div className='btn btn-primary filter-reset' onClick={this.resetFilters}>Filter zurücksetzen</div>
          <div className='filter-toggle' onClick={this.toggleFilters}><i className='fas fa-sliders-h' /></div>
        </div>
    } else {
      filterView =
        <div id='filterBar' className='filter-bar'>
          <div className='filter-row'>
            <FilterSelect selectState={this.state.selectSchool} selectFilter={this.props.staticFilters.school} dynamicFilters={this.props.dynamicFilters.school} selectLabels={labelsSchool} selectText='Alle Orte' selectChange={this.filterSchool} selectOpen={this.openSchool} sortByLabel />
            <FilterSelect selectState={this.state.selectCategory} selectFilter={this.props.staticFilters.category} dynamicFilters={this.props.dynamicFilters.category} selectLinks={linksCategory} selectLabels={labelsCategory} selectText='Alle Kategorien' selectChange={this.filterCategory} selectOpen={this.openCategory} />
            <RangeSlider label='Alter bei Kursbeginn:' rangeState={this.state.ageRange} rangeChange={this.filterAge} />
          </div>
          <div className='filter-row'>
            <FilterSelect selectState={this.state.selectLevel} selectFilter={filterLevel} dynamicFilters={this.props.dynamicFilters.level} selectLabels={labelsLevel} selectText='Alle Level' selectChange={this.filterLevel} selectOpen={this.openLevel} />
            <FilterSelect selectState={this.state.selectLicense} selectFilter={this.props.staticFilters.license} dynamicFilters={this.props.dynamicFilters.license} selectLabels={labelsLicense} selectText='Alle Führerscheine' selectChange={this.filterLicense} selectOpen={this.openLicense} />

            <div>
              <div>Kurszeitraum:</div>
              <Picker
                ref='pickRange'
                years={{ min: currentYear, max: currentYear + 2 }}
                range={dateRange}
                lang={pickerLang}
                theme='light'
                onChange={this.handleRangeChange}
              >
                <PickerBox value={rangeText(dateRange.from) + ' - ' + rangeText(dateRange.to)} onClick={this.handleClickRangeBox} />
              </Picker>
            </div>

          </div>
          <div className='btn btn-primary filter-reset' onClick={this.resetFilters}>Filter zurücksetzen</div>
          <div className='filter-toggle' onClick={this.toggleFilters}><i className='fas fa-sliders-h' /></div>
          <div className='filter-result'>
            Es wurden {this.props.resultsCount} Ergebnisse gefunden.
          </div>
        </div>
    }

    return (
      <div>
        {filterView}
      </div>
    )
  }
}

export default Filters
